import { IState } from 'shared/store';

import { selectUser } from './selectUser';

export function selectFirstAnyPhone(state: IState) {
  const user = selectUser(state);

  if (user?.isAuthenticated && user.phones) {
    return user.phones[0]?.phone ?? null;
  }

  return null;
}
